import { MessageBox } from 'element-ui';
export function getFormatDateWeek(d){
    //当前年月日时分秒
    let yy = d.getFullYear();
    let mm = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : d.getMonth()+1;
    let dd = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
    let hh = d.getHours();
    let mf = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
    let ss = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
    // var gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
    var gettime = yy+'年'+mm+'月'+dd+'日';
    //当前星期
    let wk = d.getDay()
    let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    let week = weeks[wk];
    console.log(gettime, week)
    return gettime + ' '+ week;
}

export function feedbackConfirm(message, title = '提示', options = {}) {
  return new Promise((resolve, reject) => {
      MessageBox.confirm(message, title, {
      confirmButtonText: options.confirmButtonText || '确定',
      cancelButtonText: options.cancelButtonText || '取消',
      type: options.type || 'warning',
      ...options // 允许传入其他自定义选项
    })
      .then(() => {
        resolve(); // 用户点击了“确定”
      })
      .catch(() => {
        reject(); // 用户点击了“取消”
      });
  });
}
// 缓存
export const storage = {
  set(paramName, value) {
    localStorage.setItem(paramName, typeof value === 'string' ? value : JSON.stringify(value));
  },
  get(paramName) {
    const val = localStorage.getItem(paramName);
    if (val === null) return null;
    if (isJSON(val)) {
      return JSON.parse(val);
    }
    return val;
  },
  remove(paramName) {
    localStorage.removeItem(paramName)
  }
}
// 判断是否JSON
function isJSON(str) {
  try {
    const target = JSON.parse(str)
    if (typeof target === 'object' || typeof target === 'boolean' || typeof target === 'number') {
      return true
    }
    return false
  } catch(e) {
    return false
  }
}